import { render, staticRenderFns } from "./RiskProfiler.vue?vue&type=template&id=0096e815&"
import script from "./RiskProfiler.vue?vue&type=script&lang=ts&"
export * from "./RiskProfiler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports